import React from 'react';
import { StudyCardLargeScoreIndicatorContainer } from '../atoms/styles';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';

export const StudyCardLargeScoreIndicator: React.FC<{ isCorrect?: boolean }> = ({ isCorrect }) => {
  return (
    <StudyCardLargeScoreIndicatorContainer>
      {!isCorrect ? (
        <FontAwesomeSpriteIcon icon={SpriteIconsSolid.SYNC_ALT} color="secondary" />
      ) : (
        <FontAwesomeSpriteIcon icon={SpriteIconsSolid.CHECK} color="secondary" />
      )}
    </StudyCardLargeScoreIndicatorContainer>
  );
};
